import React from "react";
import Table from "react-bootstrap/Table";
type Props = {
  raceVariations: any[];
}

const RaceDemographicsExample = ({raceVariations}: Props) => {
  return (
      <div className="overflow-auto">
        <Table className="uploadExampleTable">
        <thead>
          <tr>
            <th>Demographic</th>
            <th>Current Name Variations</th>
          </tr>
        </thead>
        <tbody>
            <tr>
              <td>Male</td>
              <td>M, Male (case-insensitive)</td>
            </tr>
            <tr>
              <td>Female</td>
              <td>F, Female (case-insensitive)</td>
            </tr>
            <tr>
              <td>Non Binary</td>
              <td>X (case-insensitive)</td>
            </tr>
            {raceVariations.sort((a: any,b: any) => a.displayName! > b.displayName! ? 1 : -1).map((races: any) => 
              <tr>
                <td>{races.displayName}</td>
                <td><div className="text-wrap">{races.variations}</div></td>
              </tr>
            )}
            {/* <tr>
              <td>Other</td>
              <td>other</td>
            </tr> */}
            <tr>
              <td>SLD</td>
              <td>Yes / No (case-insensitive) <br/> Y / N (case-insensitive)</td>
            </tr>
            <tr>
              <td>ELL</td>
              <td>Yes / No (case-insensitive) <br/> Y / N (case-insensitive)</td>
            </tr>
            <tr>
              <td>Special Education</td>
              <td>Yes / No (case-insensitive) <br/> Y / N (case-insensitive)</td>
            </tr>
            <tr>
              <td>Free & Reduced Lunch</td>
              <td>Yes / No (case-insensitive) <br/> Y / N (case-insensitive) <br/> F (case-insensitive)</td>
            </tr>
          
          </tbody>
        </Table>
      </div>
  );
};
export default RaceDemographicsExample;
